/**
 * component-image-with-text-slideshow.js
 * Slideshow controller for the "Image slideshow with text" section.
 * Lightbox modal is provided globally by ist-zoom.js.
 */

class IstSlideshow {
  constructor(el) {
    this.el      = el;
    this.slides  = Array.from(el.querySelectorAll('.ist-slideshow__slide'));
    this.dots    = Array.from(el.querySelectorAll('.ist-slideshow__dot'));
    this.prevBtn = el.querySelector('.ist-slideshow__arrow--prev');
    this.nextBtn = el.querySelector('.ist-slideshow__arrow--next');
    this.current = 0;

    this._initZoom();

    if (this.slides.length <= 1) return;

    this.autoplay     = el.dataset.autoplay === 'true';
    this.speed        = parseInt(el.dataset.speed, 10) || 5000;
    this.transition   = el.dataset.transition || 'fade';
    this.pauseOnHover = el.dataset.pauseOnHover === 'true';
    this.timer        = null;

    if (this.transition === 'slide') {
      el.classList.add('ist-slideshow--slide');
    }

    this.prevBtn && this.prevBtn.addEventListener('click', () => this.prev());
    this.nextBtn && this.nextBtn.addEventListener('click', () => this.next());
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.index, 10)));
    });

    if (this.autoplay) {
      this.startAutoplay();
      if (this.pauseOnHover) {
        el.addEventListener('mouseenter', () => this.stopAutoplay());
        el.addEventListener('mouseleave', () => this.startAutoplay());
      }
    }

    this._initSwipe();
  }

  _initZoom() {
    const zoomBtn = this.el.querySelector('.ist-slideshow__zoom');
    if (!zoomBtn) return;
    zoomBtn.addEventListener('click', () => {
      const slide   = this.slides[this.current];
      const hasSrc  = slide && (slide.dataset.zoomSrc || slide.querySelector('img'));
      if (!hasSrc) return;
      window.istGetModal().open(this, this.current);
    });
  }

  goTo(index) {
    if (index === this.current) return;

    const prev = this.current;
    this.current = ((index % this.slides.length) + this.slides.length) % this.slides.length;

    if (this.transition === 'slide') {
      const exitEl = this.slides[prev];
      exitEl.classList.add('ist-slideshow__slide--exiting');
      const onEnd = () => {
        exitEl.classList.remove('ist-slideshow__slide--exiting');
        exitEl.removeEventListener('transitionend', onEnd);
      };
      exitEl.addEventListener('transitionend', onEnd);
    }

    this.slides[prev].classList.remove('is-active');
    this.slides[prev].setAttribute('aria-hidden', 'true');
    if (this.dots[prev]) {
      this.dots[prev].classList.remove('is-active');
      this.dots[prev].setAttribute('aria-selected', 'false');
    }

    this.slides[this.current].classList.add('is-active');
    this.slides[this.current].setAttribute('aria-hidden', 'false');
    if (this.dots[this.current]) {
      this.dots[this.current].classList.add('is-active');
      this.dots[this.current].setAttribute('aria-selected', 'true');
    }
  }

  next() { this.goTo(this.current + 1); }
  prev() { this.goTo(this.current - 1); }

  startAutoplay() {
    this.stopAutoplay();
    this.timer = setInterval(() => this.next(), this.speed);
  }

  stopAutoplay() {
    if (this.timer) { clearInterval(this.timer); this.timer = null; }
  }

  _initSwipe() {
    let startX = 0;
    this.el.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });
    this.el.addEventListener('touchend', (e) => {
      const delta = e.changedTouches[0].clientX - startX;
      if (Math.abs(delta) > 40) { delta < 0 ? this.next() : this.prev(); }
    }, { passive: true });
  }
}

function initAllIstSlideshows() {
  document.querySelectorAll('.ist-slideshow[data-section-id]').forEach((el) => {
    if (!el._istInstance) {
      el._istInstance = new IstSlideshow(el);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllIstSlideshows);
} else {
  initAllIstSlideshows();
}

document.addEventListener('shopify:section:load', (e) => {
  e.target.querySelectorAll('.ist-slideshow[data-section-id]').forEach((el) => {
    el._istInstance = new IstSlideshow(el);
  });
});

document.addEventListener('shopify:block:select', (e) => {
  const slide = e.target;
  if (!slide.classList.contains('ist-slideshow__slide')) return;
  const slideshowEl = slide.closest('.ist-slideshow');
  if (!slideshowEl || !slideshowEl._istInstance) return;
  const idx = slideshowEl._istInstance.slides.indexOf(slide);
  if (idx > -1) {
    slideshowEl._istInstance.stopAutoplay();
    slideshowEl._istInstance.goTo(idx);
  }
});

document.addEventListener('shopify:block:deselect', (e) => {
  const slide = e.target;
  if (!slide.classList.contains('ist-slideshow__slide')) return;
  const slideshowEl = slide.closest('.ist-slideshow');
  if (!slideshowEl || !slideshowEl._istInstance) return;
  const instance = slideshowEl._istInstance;
  if (instance.autoplay) instance.startAutoplay();
});
